/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgentBarComponent } from '@libs/components/cep';
import { ButtonComponent, SideSheetDirective, SideSheetHeaderComponent } from '@libs/common/components';
import { AuthService } from '@libs/shared/auth';
import { UserModel } from '@libs/account/models';
import { UserService, ViewportService } from '@libs/shared/services';
import { firstValueFrom } from 'rxjs';
import { AgentSearchComponent } from '../agent-search';

@Component({
  selector: 'ui-agent-status-bar',
  imports: [
    AgentBarComponent,
    SideSheetHeaderComponent,
    SideSheetDirective,
    FormsModule,
    ReactiveFormsModule,
    AgentSearchComponent,
    ButtonComponent,

  ],
  templateUrl: './agent-status-bar.component.html',
  styleUrl: './agent-status-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentStatusBarComponent {
  private readonly userService: UserService = inject(UserService);
  private readonly authService: AuthService = inject(AuthService);
  private readonly viewportService: ViewportService = inject(ViewportService);

  public isAgentUser: Signal<boolean> = toSignal(this.authService.isUserAuthorized$('agent'), { initialValue: false });
  public currentUser: Signal<UserModel | undefined> = toSignal(this.userService.getCurrentUser());
  public isMobile: Signal<boolean> = toSignal(this.viewportService.isMobile(), { initialValue: false });
  public agentSideSheetWidth: Signal<string> = computed(() => this.isMobile() ? '100vw' : '500px');

  public logout(): void {
    void firstValueFrom(this.authService.logout());
  }
}
